import React from 'react'
import styles from './InteriorLabelInput.scss'
import cx from 'classnames'

export const InteriorLabelInput = ({
  label,
  value,
  defaultValue,
  max,
  min,
  onChange,
  noMargin,
  error,
  errorMessage,
  className
}) => {
  return (
    <label className={cx(styles.InteriorLabelInput, noMargin && styles.noMargin, className)}>
      <span>{label}</span>
      <input
        value={value}
        defaultValue={defaultValue}
        type='number'
        max={max}
        min={min}
        onChange={e => onChange(e.target.value)}
      />
      {error && <div className={styles.error}>{error && errorMessage}</div>}
    </label>
  )
}
